import { TypingIndicator, TypingIndicatorEventDTO } from '../types/index.types';

export const typingIndicatorEventDTOToTypingIndicator = (
  typingIndicatorEventDTO: TypingIndicatorEventDTO
): TypingIndicator => {
  return {
    state: typingIndicatorEventDTO.state,
    lastUpdatedAt: typingIndicatorEventDTO.timestamp,
    startedTypingAt: typingIndicatorEventDTO.timestamp,
  };
};
